
  import { computed, defineComponent, ref } from "vue"
  import "@/components/app/scss/home/Home.scss"
  import { useStore } from "vuex"
  // import SliderHome from "./SliderHome.vue"
  import AuthSection from "./Auth.vue"
  import Footer from "./Footer.vue"
  import ThemeSwitcher from "./ThemeSwitcher.vue"

  // @ts-ignore
  import logo1 from "@/assets/logo1.png"
  // @ts-ignore
  import logo2 from "@/assets/logo2.png"
  // @ts-ignore
  import logo3 from "@/assets/logo3.png"
  // @ts-ignore
  import logo4 from "@/assets/logo4.png"
  // @ts-ignore
  import logo5 from "@/assets/logo5.png"
  // @ts-ignore
  import logo6 from "@/assets/logo6.png"
  // @ts-ignore
  import vector1 from "@/assets/Vector.png"
  // @ts-ignore
  import vector2 from "@/assets/Vector(1).png"
  // @ts-ignore
  import vector3 from "@/assets/Vector(2).png"

  export default defineComponent({
    name: "HomeContent",
    components: { AuthSection, Footer, ThemeSwitcher },
    setup() {
      const store = useStore()

      const logoList = [logo1, logo2, logo3, logo4, logo5, logo6]
      const cardsList = [
        { title: "Личный словарь", link: "/", img: vector1, text: "Храните слова с цифровом виде и добавляйте по желанию транскрипции" },
        { title: "Бесплатно", link: "/", img: vector2, text: "Забудьте о подписках и ограничениях. Начните учить слова сразу после регистрации" },
        { title: "Локализация", link: "/", img: vector2, text: "Переведите интерфейс на английский, погружаясь в англоязычную среду" },
        { title: "Нет рекламы", link: "/", img: vector3, text: "Фокусируйтесь на важном и не отвлекайтесь на посторонние рекомендации" },
        { title: "Технологии машинного зрения", link: "/", img: vector1, text: "Сканируйте список слов и переносите его прямо в приложение" },
      ]

      const loginInfo = computed(() => store.getters.loginInfo)
      const errorsList = computed(() => store.getters.errorsList)
      const isAuth = computed(() => store.getters.isAuth)
      const authContent = ref(null)

      const editLogin = (isLogin: boolean) => store.commit("setLogin", isLogin)

      const scrollAuth = () => {
        // @ts-ignore
        window.scroll({ top: authContent.value.offsetTop, behavior: "smooth" })
      }

      return {
        logoList, cardsList, loginInfo, authContent,
        errorsList, isAuth, editLogin, scrollAuth
      }
    }
  })
